<script>
    import Spinner from "../../spinner/Spinner.svelte";
    import {apiFetch, apiPost} from '../../../apiFetch';
    import {createForm, Field} from "svelte-forms-lib";
    import {
        Button,
        Form,
        FormGroup,
        Input,
        Label,
    } from 'sveltestrap';
    import {goto} from "@sveltech/routify/runtime";
    import {_} from 'svelte-i18n';
    import {formatISO, formatRFC3339, parseISO} from 'date-fns';
    import FormErrors from "../../forms/FormErrors.svelte";

    let submitting = false;

    const today = new Date();
    today.setHours(20);
    today.setMinutes(0);
    today.setSeconds(0);

    let formError = null;
    export let event;
    export let completed;

    const removeTimezone = (datetime) => {
        return formatISO(datetime).substring(0, 16);
    }

    const {form, handleChange, handleSubmit} = createForm({
        initialValues: {
            event_from: event.event_from ? removeTimezone(parseISO(event.event_from)) : removeTimezone(today),
            event_to: event.event_to ? removeTimezone(parseISO(event.event_to)) : removeTimezone(today.setHours(23)),
        },
        onSubmit: values => {
            submitting = true;
            const postData = {event_date: values};
            apiPost('/events/' + event.id, postData)
                    .then((result) => {
                        if (result.status !== 200) {
                            formError = result.errors;
                        } else {
                            completed();
                        }
                        submitting = false;
                    })
                    .catch((error) => {
                        alert(error);
                        submitting = false;
                    });
        }
    });

</script>

{#await apiFetch('/organizations')}
    <Spinner/>
{:then data}
    {#if submitting}
        <Spinner/>
    {/if}
    {#if formError}
        <FormErrors errors={formError}/>
    {/if}
    <Form on:submit={handleSubmit} class="content">
        <FormGroup>
            <Label for="event_from">Event start</Label>
            <Input
                    id="event_from"
                    name="event_from"
                    type="datetime-local"
                    on:change={handleChange}
                    bind:value={$form.event_from}
            />
        </FormGroup>

        <Label for="event_to">Event end</Label>
        <FormGroup>
            <Input
                    id="event_to"
                    name="event_to"
                    type="datetime-local"
                    on:change={handleChange}
                    bind:value={$form.event_to}
            />
        </FormGroup>

        <FormGroup>
            <Button type="submit" color="primary">{$_('global.save')}</Button>
        </FormGroup>

    </Form>
{:catch error}
    {@debug error}
    <p>An error occurred!</p>
{/await}